


































































































































































import { Component } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue'; // tslint:disable-line
import { Mutation } from 'vuex-class';
import { SetHelpContentIdPayload } from '@/core/core.store';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import {
  TableEntry, // tslint:disable-line
  SwTable,
  TableColumnConfig,
  ColumnsAdjustRequestData,
  SortedColumnInfo,
  ColumnSortRequestData,  // tslint:disable-line
  SwTableColumnSelection,
} from '@libs-uuif/shared/sw-table';
import { SwIconTabDivider } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-tab';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { SwTextfield, SwExpandableTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwContentToolbar, SwContentToolbarExpand, ContentToolbarExpandFilterBlock } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar'; // tslint:disable-line
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwRadio } from '@sonicwall/unified-ui-framework/src/shared/sw-radio';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwForm, SwFormRow } from '@sonicwall/unified-ui-framework/src/shared/sw-form';
import { SwDropMenu, DropMenuItem } from '@sonicwall/unified-ui-framework/src/shared/sw-drop-menu';
import  { MswApiService } from '@/shared/msw-api-service';
// tslint:disable-next-line
import { UsageMonthlyReportMsspList, UsageDailyReportMsspList, GroupUsageRecordsType, UsageReportServiceList, GroupUsageDailyRecordsType, TenantPrefilterList,
  UsageMonthlyReportType, MSSPPrefilterResponseType, ProductPrefilterList, ServicePrefilterList, PreferensePostResponse, PreferenseGetApiResponse, PreferensePostData, MsspPrefilterList } from './types'; // tslint:disable-line
import { currentUserKey } from '@/shared/msw-constants'; // For pendo analytics
import _ from 'lodash';
import mswExportcsvService from '@/shared/msw-exportcsv.service';

const cssPrefix = 'msw-usage-report-table';

@Component({
  components: {
    SwSelect,
    SwTable,
    SwContentToolbar,
    SwContentToolbarExpand,
    SwIconButton,
    SwTextfield,
    SwExpandableTextfield,
    SwCheckbox,
    SwButton,
    SwRadio,
    SwIcon,
    SwForm,
    SwFormRow,
    SwDropMenu,
    SwTableColumnSelection,
    SwIconTabDivider,
  },
})
export default class UsageReportTable extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  expandVisible: boolean = false;
  minRange: string = '';
  maxRange: string = '';
  currentMonth:number = 0;
  currentYear: number = 0;
  skuNumber:string = '';

  pickedView: string = 'month';
  monthSelected: string[] = [];
  monthOptions: SelectOption[] = [];
  yearSelected: string = '';
  yearOptions: SelectOption[] = [];
  staticMonthOptions: SelectOption[] = [
    { id: 'January', label: String(this.$t('usageReport.January')), value: 'January' },
    { id: 'February', label: String(this.$t('usageReport.February')), value: 'February' },
    { id: 'March', label: String(this.$t('usageReport.March')), value: 'March' },
    { id: 'April', label: String(this.$t('usageReport.April')), value: 'April' },
    { id: 'May', label: String(this.$t('usageReport.May')), value: 'May' },
    { id: 'June', label: String(this.$t('usageReport.June')), value: 'June' },
    { id: 'July', label: String(this.$t('usageReport.July')), value: 'July' },
    { id: 'August', label: String(this.$t('usageReport.August')), value: 'August' },
    { id: 'September', label: String(this.$t('usageReport.September')), value: 'September' },
    { id: 'October', label: String(this.$t('usageReport.October')), value: 'October' },
    { id: 'November', label: String(this.$t('usageReport.November')), value: 'November' },
    { id: 'December', label: String(this.$t('usageReport.December')), value: 'December' },
  ];

  columnConfig: TableColumnConfig[] = [];
  adjustedColumns: ColumnsAdjustRequestData = {};
  sortedColumns: SortedColumnInfo[] = [];
  collapsedGroups: string[] = [];
  sortAsc: boolean = false;
  tableData: TableEntry[] = [];
  tempTableData: TableEntry[] = [];
  tempSerchFilterData: TableEntry[] = [];
  tableLoader: boolean = false;

  // export related
  exportMenuOpened: boolean = false;
  exportTypeSelected: string = 'csv';
  monthDataResp:UsageMonthlyReportType;
  exportMenuItems: DropMenuItem[] = [
    { id: 'csv', content: String(this.$t('usageReport.mexportCsv')) },
    { id: 'xls', content: String(this.$t('usageReport.mexportXls')) },
  ];

  serviceFilterSelected:string[] = [];
  productsFilterSelected:string[] = [];
  msspPrefilterResponseFromApi: MSSPPrefilterResponseType;
  msspPrefilterProductList: ProductPrefilterList[] = [];
  msspPrefilterServiceList: ServicePrefilterList[] = [];
  currentTimeDate: string = '';
  textExpanded: boolean = false;
  seachedText:string = '';

  msspOptions: SelectOption[] = [];
  msspSelected: string = 'All';
  tenantOptions: SelectOption[]  = [];
  tentantSelected: string = 'All';

  // column config
  tableColConfig(): TableColumnConfig[] {
    this.columnConfig = [
      {
        key: 'groupMonth',
        dataKey: 'groupMonth',
        title: this.$t('usageReport.bilMonth')
        .toString(),
        sorter: true,
        width: 120,
      },
      {
        key: 'SnapshotDate',
        dataKey: 'SnapshotDate',
        title: this.$t('usageReport.snapDte')
        .toString(),
        sorter: true,
        width: 120,
      },
      {
        key: 'tenantName',
        dataKey: 'tenantName',
        title: this.$t('usageReport.TENANT')
        .toString(),
        sorter: true,
        // tslint:disable-next-line
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              class="sw-table-row__cell__wrapper"
              style="display: inline-block; white-space: nowrap"
              v-tooltip={{ placement: 'top', persistent: false, compact: true, content: data.entry.tenantName }}>
              { data.entry.tenantName }
            </div>
          ) as VNode;
        },
      },
      {
        key: 'friendlyName',
        dataKey: 'friendlyName',
        title: this.$t('products.friendlyName')
        .toString(),
        sorter: true,
        // tslint:disable-next-line
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              class="sw-table-row__cell__wrapper"
              style="display: inline-block; white-space: nowrap"
              v-tooltip={{ placement: 'top', persistent: false, compact: true, content: data.entry.friendlyName }}>
              { data.entry.friendlyName }
            </div>
          ) as VNode;
        },
      },
      {
        key: 'serialNumber',
        dataKey: 'serialNumber',
        title: 'Serial',
        sorter: true,
        width: 110,
      },
      {
        key: 'ProductName',
        dataKey: 'ProductName',
        title: this.$t('common.product')
        .toString(),
        // tslint:disable-next-line
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              class="sw-table-row__cell__wrapper"
              style="display: inline-block; white-space: nowrap"
              v-tooltip={{ placement: 'top', persistent: false, compact: true, content: data.entry.ProductName }}>
              { data.entry.ProductName }
            </div>
          ) as VNode;
        },
        sorter: true,
      },
      {
        key: 'Service',
        dataKey: 'Service',
        title: this.$t('bulkact.service')
        .toString(),
        // tslint:disable-next-line
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              class="sw-table-row__cell__wrapper"
              style="display: inline-block; white-space: nowrap"
              v-tooltip={{ placement: 'top', persistent: false, compact: true, content: data.entry.Service }}>
              { data.entry.Service }
            </div>
          ) as VNode;
        },
        sorter: true,
      },
      {
        key: 'SKU',
        dataKey: 'SKU',
        title: `${this.$t('quote.sku')
        .toString()}#`,
        sorter: true,
        width: 100,
      },
      {
        key: 'SKUDescription',
        dataKey: 'SKUDescription',
        title: `${this.$t('quote.sku')
        .toString()} ${this.$t('common.description')
        .toString()}`,
        // tslint:disable-next-line
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              class="sw-table-row__cell__wrapper"
              style="display: inline-block; white-space: nowrap"
              v-tooltip={{ placement: 'top', persistent: false, compact: true, content: data.entry.SKUDescription }}>
              { data.entry.SKUDescription }
            </div>
          ) as VNode;
        },
        sorter: true,
      },
      {
        key: 'BilledQuantity',
        dataKey: 'BilledQuantity',
        title: 'Billed Quantity',
        sorter: true,
        width: 130,
      },
    ];
    if (this.isMasterMssp) {
      this.columnConfig.splice(2, 0, {
        key: 'msspName',
        dataKey: 'msspName',
        title: this.$t('usageReport.MSSP')
        .toString(),
        sorter: true,
        // tslint:disable-next-line
        render: (h: CreateElement, data: { entry: TableEntry }): VNode => {
          return (
            <div
              class="sw-table-row__cell__wrapper"
              style="display: inline-block; white-space: nowrap"
              v-tooltip={{ placement: 'top', persistent: false, compact: true, content: data.entry.tenantName }}>
              { data.entry.msspName }
            </div>
          ) as VNode;
        },
      });
    }
    return this.columnConfig;
  }

   // column adjust
  onRequestAdjustColumns(data: ColumnsAdjustRequestData) {
    this.adjustedColumns = data;
  }

  // For sorting the rows
  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  get isMasterMssp() {
    const roles = JSON.parse(this.$store.getters.getUserInfo).user.roles || [];
    return roles.indexOf('MASTERMSSP') > -1 ? true : false;
  }

  // Filter Layout construct Starts
  get filterBlockGrid() : ContentToolbarExpandFilterBlock[][] {
    return [
      [
        { title: String(this.$t('usageReport.producta')), content: this.viewProductsFilterRender, width: 250 },
        { title: String(this.$t('usageReport.services')), content: this.viewServicesFilterRender, width: 275 },
        { title: String(this.$t('usageReport.Units')), content: this.viewUnitsFilterRender, width: 250 },
        { title: String(this.$t('quote.sku')), content: this.viewSKUFilterRender, width: 250 },
      ],
    ];
  }

  private viewProductsFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <SwForm props-layout-only={true}>
        {
          this.msspPrefilterProductList.map<VNode>((ele: ProductPrefilterList) => {
            return (
              <SwFormRow no-label>
                <div class={['sw-flexbox__flex']}>
               <SwCheckbox
                  name={'group'}
                  props-value={ele.ProductID}
                  props-checked={this.productsFilterSelected.includes(ele.ProductID)}
                  on-change={() => {
                    if (this.productsFilterSelected.includes(ele.ProductID)) {
                      this.productsFilterSelected.splice(this.productsFilterSelected.indexOf(ele.ProductID), 1);
                    } else {
                      this.productsFilterSelected.push(ele.ProductID);
                    }
                    this.changeServiceList();
                  }}>
                { ele.ProductName }
                  </SwCheckbox>
                  </div>
              </SwFormRow>
            ) as VNode;
          })
        }
      </SwForm>
    ) as VNode;
  }

  changeServiceList() {
    this.msspPrefilterServiceList = [];
    this.productsFilterSelected.map((item: string) => {
      const productListFiltered = this.msspPrefilterProductList.filter((ele: ProductPrefilterList) => ele.ProductID === item);
      const serviceListFiltered = productListFiltered[0] ? productListFiltered[0].Services : [];
      this.msspPrefilterServiceList = [...this.msspPrefilterServiceList, ...serviceListFiltered];
    });
  }

  private viewServicesFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <SwForm props-layout-only={true}>
        {
          this.msspPrefilterServiceList.map<VNode>((ele: ServicePrefilterList) => {
            return (
              <SwFormRow no-label>
                <div class={['sw-flexbox__flex']}>
               <SwCheckbox
                  name={'group'}
                  props-value={ele.ServiceID}
                  props-checked={this.serviceFilterSelected.includes(ele.ServiceID)}
                  on-change={() => {
                    if (this.serviceFilterSelected.includes(ele.ServiceID)) {
                      this.serviceFilterSelected.splice(this.serviceFilterSelected.indexOf(ele.ServiceID), 1);
                    } else {
                      this.serviceFilterSelected.push(ele.ServiceID);
                    }
                  }}>
                { ele.ServiceName }
                  </SwCheckbox>
                  </div>
              </SwFormRow>
            ) as VNode;
          })
        }
      </SwForm>
    ) as VNode;
  }

  private viewUnitsFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
      <div>{ this.$t('tenantMgmt.page.range')
        .toString() }</div>
      <div style={{ width: '65px',  paddingTop: '10px' }} class={['usage-report-toolbar', 'sw-flexbox']}>
      <SwTextfield
        style={{ width:'50px' }}
        props-name={'min'}
        props-value={this.minRange}
        props-placeholder={String(this.$t('usageReport.min'))}
        props-expandWidth={100}
        on-input={(e: any) => { this.minRange = e; }}
      ></SwTextfield>
      <span style={{ padding: '5px 10px' }}> - </span>
      <SwTextfield
        style={{ width:'50px' }}
        props-name={'max'}
        props-value={this.maxRange}
        props-placeholder={String(this.$t('usageReport.max'))}
        props-expandWidth={100}
        on-input={(e: any) => { this.maxRange = e; }}
      ></SwTextfield>
      </div>
      </div>
    ) as VNode;
  }

  private viewSKUFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
      <div>{ `${String(this.$t('products.enter'))} ${String(this.$t('quote.sku'))}` }</div>
      <div style={{ width: '65px',  paddingTop: '10px' }} class={['usage-report-toolbar', 'sw-flexbox']}>
      <SwTextfield
        props-name={'sku'}
        props-value={this.skuNumber}
        props-placeholder={String(this.$t('quote.sku'))}
        on-input={(e: any) => { this.skuNumber = e; }}
      ></SwTextfield>
      </div>
      </div>
    ) as VNode;
  }
  // Filter Layout construct Starts

  onMsspOptionChange() {
    if (this.msspSelected !== 'All') {
      this.tentantSelected === 'All';
      this.tenantOptions = [{
        id: 'All',
        value: 'All',
        label: String(this.$t('usageReport.allTenants')),
      }];
      this.msspPrefilterResponseFromApi.content.MSSPs.map((ele: MsspPrefilterList) => {
        if (ele.Tenants) {
          ele.Tenants.map((item: TenantPrefilterList) => {
            this.tenantOptions.push({
              id: item.TenantName,
              value: item.productGroupId,
              label: item.TenantName,
            });
          });
        }
      });
    }
    this.onMsspTenantOptionChange();
  }

  async onTenantOptionChange(e:any = '') {
    console.warn(e);
    this.tentantSelected = e;
    await this.onMsspTenantOptionChange();
  }

  async onMsspTenantOptionChange() {
    await this.loadTableApi();
    if (!(this.msspSelected === 'All' && this.tentantSelected === 'All')) {
      this.tableData = this.tempTableData.filter((row: any) => {
        let flag = false;
        if (((row.msspName === this.msspSelected) || (this.msspSelected === 'All')) && ((row.tenantName === this.tentantSelected) || (this.tentantSelected === 'All'))) {
          flag = true;
          return flag;
        }
      });
    }
  }

  // Filter starts
  onClear() {
    this.resetFilterValues();
    this.tableData = this.tempTableData;
    this.expandVisible = !this.expandVisible;
  }

  resetFilterValues() {
    this.serviceFilterSelected = [];
    this.productsFilterSelected = [];
    this.minRange = '';
    this.maxRange = '';
    this.skuNumber = '';
    this.msspSelected = 'All';
    this.tentantSelected = 'All';
  }

  searchFilter() {
    setTimeout(() => {
      this.handleSearchFilter();
    }, 1000); // tslint:disable-line
  }

  handleSearchFilter() {
    this.tempSerchFilterData = this.tableData;
    if (this.seachedText !== '') {
      this.tableData = this.tempSerchFilterData.filter((ele:any) => {
        // console.warn(ele);
        // console.warn(ele.SnapshotDate.includes(this.seachedText));
        // console.warn(ele.msspName.includes(this.seachedText));
        // console.warn(ele.tenantName.includes(this.seachedText));
        // console.warn(ele.friendlyName.includes(this.seachedText));
        if (ele?.SnapshotDate?.includes(this.seachedText) || ele?.msspName?.includes(this.seachedText) || ele?.tenantName?.includes(this.seachedText) || ele?.friendlyName?.includes(this.seachedText) ||
        ele?.serialNumber?.includes(this.seachedText) || ele?.Product?.includes(this.seachedText) || ele?.Service?.includes(this.seachedText) ||
        ele?.SKU?.includes(this.seachedText) || ele?.SKUDescription?.includes(this.seachedText) || ele?.BilledQuantity?.includes(this.seachedText)) {
          return ele;
        }
      });
      // console.warn(this.tableData);
    } else {
      this.tableData = this.tempTableData;
    }
  }

  onApply() {
    this.expandVisible = !this.expandVisible;
    this.onApplyFilter();
  }

  async onApplyFilter() {
    if (this.productsFilterSelected.length > 0) {
      this.tableData = this.tempTableData.filter((ele:any) => {
        if (this.productsFilterSelected.some((prd:any) => ele.productId === Number(prd))) {
          return ele;
        }
      });
    }
    if (this.serviceFilterSelected.length > 0 && this.serviceFilterSelected.length > 0) {
      this.tableData = this.tableData.filter((ele:any) => {
        if (this.serviceFilterSelected.some((ser:any) => ele.serviceId === Number(ser))) {
          return ele;
        }
      });
    } else if (this.serviceFilterSelected.length > 0) {
      this.tableData = this.tempTableData.filter((ele:any) => {
        if (this.serviceFilterSelected.some((ser:any) => ele.serviceId === Number(ser))) {
          return ele;
        }
      });
    }
    if (this.skuNumber !== '' && (this.serviceFilterSelected.length > 0 || this.serviceFilterSelected.length > 0)) {
      debugger;
      this.tableData = this.tableData.filter((ele:any) => {
        if (ele.SKU === this.skuNumber) {
          return ele;
        }
      });
    } else if (this.skuNumber !== '') {
      this.tableData = this.tempTableData.filter((ele:any) => {
        if (ele.SKU === this.skuNumber) {
          return ele;
        }
      });
    }
    // if (this.tentantSelected !== 'ALL' && this.tentantSelected !== '' && (this.skuNumber !== '' || this.serviceFilterSelected.length > 0 || this.serviceFilterSelected.length > 0)) {
    //   this.tableData = this.tableData.filter((ele:any) => {
    //     if (ele.tenantName === this.tentantSelected) {
    //       return ele;
    //     }
    //   });
    // }
    // if (this.msspSelected !== 'ALL' && this.msspSelected !== '' && (this.skuNumber !== '' || this.serviceFilterSelected.length > 0 || this.serviceFilterSelected.length > 0)) {
    //   this.tableData = this.tableData.filter((ele:any) => {
    //     if (ele.tenantName === this.tentantSelected) {
    //       return ele;
    //     }
    //   });
    // }
  }

  onSaveApply() {
    const filterToBeSaved = {
      msspSelected: this.msspSelected,
      tenantSelected: this.tentantSelected,
      productSelected: this.productsFilterSelected,
      servicesSelected: this.serviceFilterSelected,
      rangeMinSelected: this.minRange,
      rangeMaxSelected: this.maxRange,
      skuSelected: this.skuNumber,
    };
    const formattedFilterObj = JSON.stringify(filterToBeSaved);
    MswApiService.usageReport.postFilterPreference(formattedFilterObj)
      .then((resp: PreferensePostResponse) => {
        this.onApplyFilter();
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
      })
      .catch(() => {
      });
  }
  // filter Ends

  onChangeExport(itemId: string) {
    if (itemId === 'csv') {
      this.exportCsv();
    } else {
      this.exportXls();
    }
  }

  exportCsv() {
    mswExportcsvService.export(this.mapToExport(this.tableData), String(this.$t('usageReport.csvTitle')));
  }

  exportXls() {
    mswExportcsvService.export(this.mapToExport(this.tableData), String(this.$t('usageReport.xlsTitle')));
  }

  mapToExport(csvData: any[]) {
    let filterJson: any[] = [];
    const headerObj: any = {};
    this.columnConfig?.forEach((entry: TableColumnConfig) => {
      const key = entry?.title?.toString() || '';
      headerObj[key] = key.toUpperCase();
    });
    const tempJson: any[] = [headerObj];
    csvData?.forEach((dataItem:any) => {
      const obj = {};
      this.columnConfig?.forEach((item) => {
        if (item?.dataKey) {
          // @ts-ignore
          obj[item.title] = dataItem[item?.dataKey];
        }
      });
      tempJson.push(obj);
    });
    filterJson = filterJson.concat(tempJson);
    return filterJson;
  }

  // Helper method
  fetchMonthId(mthSelected: string[]) {
    const monthNum: number[] = [];
    mthSelected.map((ele: string) => {
      const findMonthIndex = this.staticMonthOptions.findIndex((item: SelectOption) => item.id === ele);
      monthNum.push(findMonthIndex + 1);
    });
    return monthNum.join(',');
  }

  // Formatting (Resetting dropdown values) start here
  formatMsspOption() {
    const msspOption: SelectOption[] = [{
      id: 'All',
      value: 'All',
      label: String(this.$t('usageReport.allMssps')),
    }];
    if (this.msspPrefilterResponseFromApi && this.msspPrefilterResponseFromApi.content && this.msspPrefilterResponseFromApi.content.MSSPs) {
      this.msspPrefilterResponseFromApi.content.MSSPs.map((ele: any) => {
        if (ele.MSSPName) {
          msspOption.push({
            id: ele.MSSPName.toString(),
            label: ele.MSSPName,
            value: ele.MSSPID,
          });
        }
      });
    }
    this.msspOptions = [...msspOption];
  }

  formatTenantOption() {
    const tenantOption: SelectOption[] = [{
      id: 'All',
      value: 'All',
      label: String(this.$t('usageReport.allTenants')),
    }];
    if (this.msspPrefilterResponseFromApi && this.msspPrefilterResponseFromApi.content && this.msspPrefilterResponseFromApi.content.MSSPs) {
      this.msspPrefilterResponseFromApi.content.MSSPs.map((ele: MsspPrefilterList) => {
        if (ele.Tenants) {
          ele.Tenants.map((item: TenantPrefilterList) => {
            tenantOption.push({
              id: item.TenantName,
              label: item.TenantName,
              value: item.productGroupId,
            });
          });
        }
      });
    }
    this.tenantOptions = [...tenantOption];
  }

  formatProductListFilter() {
    this.msspPrefilterProductList = [];
    if (this.msspPrefilterResponseFromApi && this.msspPrefilterResponseFromApi.content && this.msspPrefilterResponseFromApi.content.Products) {
      this.msspPrefilterProductList = _.uniqWith(this.msspPrefilterResponseFromApi.content.Products, (pre, cur) => {
        if (pre.ProductID === cur.ProductID) {
          cur.Services = [...cur.Services, ...pre.Services];
          return true;
        }
        return false;
      });
      // this.msspPrefilterResponseFromApi.content.Products.map((ele: any) => {
      //   this.msspPrefilterProductList.push(ele);
      // });
    }
  }

  formatServicesFilter() {
    this.msspPrefilterServiceList = [];
    if (this.msspPrefilterResponseFromApi && this.msspPrefilterResponseFromApi.content && this.msspPrefilterResponseFromApi.content.Products) {
      this.msspPrefilterResponseFromApi.content.Products.map((ele: ProductPrefilterList) => {
        ele.Services.map((item: ServicePrefilterList) => {
          const findServiceIndex = this.msspPrefilterServiceList.findIndex((service: ServicePrefilterList) => service.ServiceID === item.ServiceID);
          if (findServiceIndex === -1) {
            this.msspPrefilterServiceList.push(item);
          }
        });
      });
    }
  }
  formatFilter() {
    this.formatMsspOption();
    this.formatTenantOption();
    this.formatProductListFilter();
    this.formatServicesFilter();
  }
  // Formatting (Resetting dropdown values) ends here

  // Date settings starts
  async setMonthYearSelectOption() {
    return new Promise((res: any) => {
      const currentDate = this.currentTimeDate.split(' ')[0];
      this.currentMonth = Number(currentDate.split('/')[0]);
      this.currentYear = Number(currentDate.split('/')[2]);
      if (this.currentMonth === 1) {
        this.yearOptions = [{
          id: (this.currentYear - 3).toString(),
          label: (this.currentYear - 3).toString(),
          value: (this.currentYear - 3).toString(),
        }, {
          id: (this.currentYear - 2).toString(),
          label: (this.currentYear - 2).toString(),
          value: (this.currentYear - 2).toString(),
        }, {
          id: (this.currentYear - 1).toString(),
          label: (this.currentYear - 1).toString(),
          value: (this.currentYear - 1).toString(),
        }];
        this.yearSelected = (this.currentYear - 1).toString();
        this.monthSelected = [this.staticMonthOptions[11].id];
        this.monthOptions = [...this.staticMonthOptions];
      } else {
        this.yearOptions = [{
          id: (this.currentYear - 2).toString(),
          label: (this.currentYear - 2).toString(),
          value: (this.currentYear - 2).toString(),
        }, {
          id: (this.currentYear - 1).toString(),
          label: (this.currentYear - 1).toString(),
          value: (this.currentYear - 1).toString(),
        }, {
          id: this.currentYear.toString(),
          label: this.currentYear.toString(),
          value: this.currentYear.toString(),
        }];
        this.yearSelected = this.currentYear.toString();
        this.monthSelected = [this.staticMonthOptions[this.currentMonth - 2].id];
        this.monthOptions = [...this.staticMonthOptions];
        this.monthOptions = this.monthOptions.slice(0, this.currentMonth - 1);
      }
      res(true);
    });
  }

  onChangeMonthView() {
    const tempOption = [...this.monthSelected];
    this.monthSelected = [];
    this.monthOptions = [...this.staticMonthOptions];
    if (this.yearSelected === this.currentYear.toString()) {
      this.monthOptions = this.monthOptions.slice(0, this.currentMonth - 1);
    }
    tempOption.map((ele: string) => {
      if (this.monthOptions.filter((item: SelectOption) => item.id === ele)[0] !== undefined) {
        this.monthSelected.push(ele);
      }
    });
    const monthSelectedTemp: string[] = [];
    this.staticMonthOptions.map((ele: any) => {
      if (this.monthSelected.includes(ele.id)) {
        monthSelectedTemp.push(ele.id);
      }
    });
    this.monthSelected = [...monthSelectedTemp];
    this.tableData = [];
    this.loadTableApi(true);
  }
  // Date settings starts

  // Api calls starts
  async fetchMSSPUsageReport() {
    const msspSelected: any = this.msspOptions.filter((ele: SelectOption) => ele.id === this.msspSelected);
    const tenantSelected: any = this.tenantOptions.filter((ele: SelectOption) => ele.id === this.tentantSelected);
    const bodyToBePosted: any = {
      pageno: -1,
      pagesize: '50',
      msspids: msspSelected.length > 0 ? msspSelected[0].value : 'All',
      productGroupIds :  tenantSelected.length > 0 ? tenantSelected[0].value : 'All',
      viewBy: 'Monthly',
      monthNumbers: this.fetchMonthId(this.monthSelected),
      // monthNumbers: '1,2,3',
      yearNumber: this.yearSelected === '' ? '0' : this.yearSelected,
      // yearNumber: '2023',
    };
    return new Promise((res, rej) => {
      MswApiService.usageReport.postUsageReportData(bodyToBePosted)
      .then((resp: UsageMonthlyReportType) => {
        this.monthDataResp = resp;
        this.currentTimeDate = resp.content.serverTime;
        if (resp.content.msspusagelist && resp.content.msspusagelist.length > 0) {
          if (resp.content.msspusagelist[0].groupUsageRecords && resp.content.msspusagelist[0].groupUsageRecords.length > 0) {
            const usageRecords:any[] = resp.content.msspusagelist[0].groupUsageRecords || [];
            usageRecords.forEach((item: any, index: number) => {
              item['_key'] = index + 1;
            });
            this.tableData = usageRecords;
            this.tempTableData = this.tableData;
          }
        }
        res(resp);
      })
      .catch(() => {
        rej(false);
      });
    });
  }

  getMSSPDetails() {
    return new Promise((res: any) => {
      MswApiService.usageReport.getMsspListWithSource()
      .then((resp: MSSPPrefilterResponseType) => {
        this.msspPrefilterResponseFromApi = resp;
        if (this.msspPrefilterResponseFromApi.content.pendoEnabled &&
          this.msspPrefilterResponseFromApi.content.pendoEnabled === 'YES') {
          this.startPendoAnalytics();
        }
        this.formatFilter();
        res(true);
      })
      .catch(() => {
        res(true);
      });
    });
  }

  getPrefilterData() {
    return new Promise((res: any) => {
      MswApiService.usageReport.getMsspPreferenceFilter()
      .then((resp: PreferenseGetApiResponse) => {
        const extractJsonInfo: PreferensePostData = JSON.parse(resp.preferenceData);
        this.msspSelected = extractJsonInfo.msspSelected;
        this.tentantSelected = extractJsonInfo.tenantSelected;
        this.productsFilterSelected = extractJsonInfo.productSelected;
        this.serviceFilterSelected = extractJsonInfo.servicesSelected;
        this.minRange = extractJsonInfo.rangeMinSelected;
        this.maxRange = extractJsonInfo.rangeMaxSelected;
        this.formatFilter();
        this.onApplyFilter();
        res(true);
      })
      .catch(() => {
        res(true);
      });
    });
  }
  // Api calls ends

  async loadTableApi(enableLoading: boolean = false) {
    try {
      this.tableLoader = true;
      if (enableLoading) { this.$store.commit('startLoading'); }
      await this.fetchMSSPUsageReport();
      this.tableColConfig();
      await this.onApplyFilter();
      if (enableLoading) { this.$store.commit('stopLoading'); }
      this.tableLoader = false;
    } catch {
      this.tableLoader = false;
      if (enableLoading) { this.$store.commit('stopLoading'); }
    }
  }

  async initializeTable() {
    try {
      this.tableLoader = true;
      this.$store.commit('startLoading');
      await this.getMSSPDetails();
      await this.getPrefilterData();
      await this.loadTableApi();
      await this.setMonthYearSelectOption();
      await this.loadTableApi();
      await this.onApplyFilter();
      this.tableLoader = false;
      this.$store.commit('stopLoading');
    } catch {
      this.tableLoader = false;
      this.$store.commit('stopLoading');
    }
  }

  async created() {
    this.setHelpContentId({ helpId: ['regular-billing-report'] });
    await this.initializeTable();
  }

  // For Pendo Analytics
  startPendoAnalytics() {
    const currentUser : any = localStorage.getItem(currentUserKey);
    const userDetails = JSON.parse(currentUser) || '';
    if (userDetails !== '') {
      (window as any).pendo.initialize({
        visitor: {
          id: userDetails.userId || '',
          username: userDetails.userId || '', // For SFDC integ //
          org:  this.msspPrefilterResponseFromApi.content.orgName || '', // email domain //
          mssp: this.msspPrefilterResponseFromApi.content.MSSPTier || '', // MSSP tier //
        },
        account: {
          id: this.msspPrefilterResponseFromApi.content.orgID || '',  // OrgId for Company//
          name: this.msspPrefilterResponseFromApi.content.orgName || '', // Org Name
        },
      });
    }
  }
}
